var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_4882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1169_4882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 16.6663H43.3327V43.333H16.666V16.6663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1169_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2893 29.9998C42.2867 31.096 42.2743 32.1922 42.2593 33.2883C42.2412 34.6107 42.2208 35.9337 41.8891 37.2335C41.5414 38.5966 40.8554 39.7721 39.7882 40.6423C38.6637 41.5594 37.3044 42.0415 35.8373 42.1307C33.8915 42.249 31.9448 42.2958 29.9982 42.2912C28.0515 42.2958 26.1048 42.249 24.1591 42.1307C22.692 42.0415 21.3327 41.5594 20.2081 40.6423C19.1409 39.7721 18.455 38.5966 18.1072 37.2335C17.7755 35.9337 17.7551 34.6107 17.737 33.2883C17.722 32.1922 17.7096 31.096 17.707 29.9998C17.7096 28.9037 17.722 27.8075 17.737 26.7114C17.7551 25.3889 17.7755 24.0659 18.1072 22.7661C18.455 21.4031 19.1409 20.2276 20.2081 19.3573C21.3327 18.4402 22.692 17.9582 24.1591 17.869C26.1048 17.7507 28.0515 17.7039 29.9982 17.7085C31.9448 17.7039 33.8915 17.7507 35.8373 17.869C37.3044 17.9582 38.6637 18.4402 39.7882 19.3573C40.8554 20.2276 41.5414 21.4031 41.8891 22.7661C42.2208 24.0659 42.2412 25.3889 42.2593 26.7114C42.2743 27.8075 42.2867 28.9037 42.2893 29.9998Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.416 30C35.416 33.0203 32.9676 35.4688 29.9473 35.4688C26.927 35.4688 24.4785 33.0203 24.4785 30C24.4785 26.9797 26.927 24.5312 29.9473 24.5312C32.9676 24.5312 35.416 26.9797 35.416 30Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 22.9687C38.75 23.8317 38.0504 24.5312 37.1875 24.5312C36.3246 24.5312 35.625 23.8317 35.625 22.9687C35.625 22.1058 36.3246 21.4062 37.1875 21.4062C38.0504 21.4062 38.75 22.1058 38.75 22.9687Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_4882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(16.666 16.6665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ec0def85029ad8075c23ac356ea8cfa7.svg";
export { ForwardRef as ReactComponent };